// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DayType } from './DayType';
export class HolidayDescription {
    constructor() {
        this.sessionPeriods = null;
    }
    static createHolidayKey(year, month, day) {
        const formattedYear = String(year).padStart(4, '0');
        const formattedMonth = String(month).padStart(2, '0');
        const formattedDay = String(day).padStart(2, '0');
        return `${formattedYear}-${formattedMonth}-${formattedDay}`;
    }
    getDayOfWeek() {
        const date = new Date(this.year, this.month - 1, this.day);
        return date.getDay();
    }
    HasPeriods() {
        return !isNullOrUndefined(this.sessionPeriods) && this.sessionPeriods.length > 0;
    }
    GetFormattedDate() {
        const formattedDay = String(this.day).padStart(2, '0');
        const formattedMonth = String(this.month).padStart(2, '0');
        const formattedYear = String(this.year).padStart(4, '0');
        return `${formattedDay}.${formattedMonth}.${formattedYear}`;
    }
    GetHolidayPeriods() {
        return this.sessionPeriods;
    }
    IsNotWorking() {
        return this.holidayType === DayType.NOT_WORKING;
    }
    IsShorted() {
        return this.holidayType === DayType.SHORTED;
    }
    IsWorking() {
        return !this.IsNotWorking();
    } // may be usefull
}
